import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../../action/logout-action';

interface SearchConsultationState {
  filters: any;
  searchText: string;
  lastExploreTimestamp: number | null;
  lastDetailTimestamp: number | null;
}

const initialState: SearchConsultationState = {
  filters: null,
  searchText: '',
  lastExploreTimestamp: null,
  lastDetailTimestamp: null,
};

const searchConsultationSlice = createSlice({
  name: 'searchConsultation',
  initialState,
  reducers: {
    setSearchFilters: (state, action: PayloadAction<{ filters?: any; searchText?: string }>) => {
      if (action.payload.filters !== undefined) {
        state.filters = action.payload.filters;
      }
      if (typeof action.payload.searchText === 'string') {
        state.searchText = action.payload.searchText;
      }
    },
    clearSearchFilters: (state) => {
      state.filters = null;
      state.searchText = '';
      state.lastExploreTimestamp = null;
      state.lastDetailTimestamp = null;
    },
    setLastExploreTimestamp: (state, action: PayloadAction<number>) => {
      state.lastExploreTimestamp = action.payload;
    },
    setLastDetailTimestamp: (state, action: PayloadAction<number>) => {
      state.lastDetailTimestamp = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const {
  setSearchFilters,
  clearSearchFilters,
  setLastExploreTimestamp,
  setLastDetailTimestamp,
} = searchConsultationSlice.actions;

export default searchConsultationSlice.reducer;
